module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-meet-doc"
  }, [_c('div', {
    staticClass: "custom-meet-doc__container"
  }, [_c('div', {
    staticClass: "custom-meet-doc__intro",
    domProps: {
      "innerHTML": _vm._s(_vm.props.intro)
    }
  }), _c('HeaderSection', {
    staticClass: "custom-meet-doc__title-section",
    attrs: {
      "content": _vm.props.body,
      "bodyAlign": 'left'
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(props) {
        return _c('div', {
          staticClass: "custom-meet-doc__title",
          domProps: {
            "innerHTML": _vm._s(props.content)
          }
        })
      }
    }, {
      key: "body",
      fn: function(props) {
        return _c('div', {
          staticClass: "custom-meet-doc__body",
          domProps: {
            "innerHTML": _vm._s(props.content)
          }
        })
      }
    }])
  }), _c('div', {
    staticClass: "custom-meet-doc__acc",
    domProps: {
      "innerHTML": _vm._s(_vm.props.membership)
    }
  }), _c('Carousel', {
    staticClass: "custom-meet-doc__slider",
    attrs: {
      "perPage": 1,
      "autoplay": true,
      "autoplayHoverPause": true,
      "autoplayTimeout": 3500,
      "easing": 'ease-in-out',
      "loop": true,
      "paginationEnabled": false,
      "navigationEnabled": true,
      "navigationNextLabel": _vm.arrow,
      "navigationPrevLabel": _vm.arrow
    }
  }, _vm._l((_vm.props.slides), function(slide, i) {
    return _c('Slide', {
      key: i,
      staticClass: "custom-meet-doc__slide"
    }, [_c('div', {
      staticClass: "custom-meet-doc__image",
      style: ({
        backgroundImage: 'url(' + slide.image + ')'
      })
    })])
  }), 1), _c('div', {
    staticClass: "custom-meet-doc__outro",
    domProps: {
      "innerHTML": _vm._s(_vm.props.outro)
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55a958f2","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-meet-doc/custom-meet-doc.pug
// module id = 652
// module chunks = 1